'use strict';

angular.module('adelementAdminApp')
    .controller('RoleMappingController', function ($scope, $state, RoleMapping, ParseLinks) {

        $scope.roleMappings = [];
        $scope.predicate = 'id';
        $scope.reverse = true;
        $scope.page = 1;
        $scope.loadAll = function() {
            RoleMapping.query({page: $scope.page - 1, size: 20, sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.roleMappings = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.roleMapping = {
                role: null,
                uiRole: null,
                accessLevel: null,
                accessRight: null,
                type: null,
                id: null
            };
        };
    });
